import { EVENT_TYPES } from './event-types'

export default {
  SUBSCRIPTIONS_CUSTOMER_ACTIVATE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_customer_activate_clicked',
  },
  SUBSCRIPTIONS_CUSTOMER_CANCEL_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_customer_cancel_clicked',
  },
  SUBSCRIPTIONS_OPT_IN_BANNER_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_opt_in_banner_viewed',
  },
  SUBSCRIPTIONS_ACTIVE_STATUS_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_active_status_viewed',
  },
  SUBSCRIPTIONS_CUSTOMER_LEARN_MORE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_customer_learn_more_clicked',
  },
  SUBSCRIPTIONS_CUSTOMER_BENEFITS_POPUP_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_customer_benefits_popup_viewed',
  },
  PAYMENT_SUBSCRIPTIONS_CUSTOMER_BENEFITS_POPUP_HIDE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_customer_benefits_popup_hide_clicked',
  },
  PAYMENT_SUBSCRIPTIONS_SERVICE_FEE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_service_fee_viewed',
  },
}
